import { WithStyles, withStyles } from '@mui/styles';
import { SecurityCurrencyAssetPair } from '@tassat/fred-extended-definitions';

import { FirmDetails } from './firmDetails';
import { muiStyles } from './firmDetailsStyles';

export interface IFirmDetailsProps extends WithStyles<typeof muiStyles> {
    firmId: string;
    assetPair: SecurityCurrencyAssetPair;
}

export default withStyles(muiStyles)(FirmDetails);